import { render, staticRenderFns } from "./AppLeftSideBar.vue?vue&type=template&id=4500a042&"
import script from "./AppLeftSideBar.vue?vue&type=script&lang=ts&"
export * from "./AppLeftSideBar.vue?vue&type=script&lang=ts&"
import style0 from "./AppLeftSideBar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VChip,VRow})
